<template>
  <div class="container" >  
    <div v-if="typeControlPermission"> 
      <div v-if="JSON.stringify(obj)!=='{}'">
        <div class="text-center">
            <Organizer @done="done" ref="con2" />
        </div>   
      </div>
    </div>
    <span v-else v-text="'您沒有管理權限'"></span>    
        <b-modal ref="my-loading" id="modal-2" title="Loading" @hide="onHide" centered hide-footer hide-header>
          <div class="text-center">
              <b-spinner  variant="primary" label="Text Centered"></b-spinner>
              <strong >Loading....</strong>
          </div>
        </b-modal> 

        <b-alert
          v-model="showTop"
          class="position-fixed fixed-top m-0 rounded-0"
          style="z-index: 2000;"
          variant="success"
          dismissible
        >
          更新成功
        </b-alert>              

  </div>        
</template>
<script>
import { mapState } from "vuex";
import Organizer from '../../act/Organizer'

export default {
  name: 'Org_generate',   
  components: {
    Organizer,
  },

  data() {
    return {
      obj: {},
      rsdata:null,
      showTop:false,
      loading: false,   
      isFirstLoad: true,                        
            };
  },
  mounted(){
    this.obj=this.datas.find(item => item.id == this.defaultval.id)
  },
  computed: {
    ...mapState("account", ["status", "user"]), 
    ...mapState("makeorg", ["datas","defaultval"]),
    typeControlPermission() {
                  const currentVal = this.$route.name;
                // 取得 acts_permissions 陣列，從 defaultval.permissions.acts_permissions
                const acts_permissions = this.defaultval?.permissions?.acts_permissions || [];
                // 找到 vals 為 Advancementoption 的主功能
                const adv = acts_permissions.find(item => item.vals === "Orgmanagement");
                if (!adv) return null;
                // 在其 acts_detailpermission 裡找 vals 為 Type_control 的細項
                return adv.acts_detailpermission.find(d => d.vals === currentVal) || null;
        }     
  }, 
  watch: {
      defaultval(val){
          this.obj=this.datas.find(item => item.id == val.id)
          this.isFirstLoad = true;
      },
  },
  methods: {   
    done(rs){
        this.rsdata = rs
        // 👈 只有非首次載入時才顯示成功訊息
        if (!this.isFirstLoad) {
          this.showTop = true;
          setTimeout(() => {                           
            this.showTop = false;
            clearInterval();
          }, 2000);
        } else {
          // 👈 首次載入完成後，標記為非首次
          this.isFirstLoad = false;
        }
    },
    onReset(event) {
        event.preventDefault()
        this.$nextTick(() => {

        })
    },  
 
    onHide(evt) {
        if(evt.trigger === "backdrop"){
            evt.preventDefault();
        }
    }, 
    catImg(imgs) {
      return require(`../../assets/${imgs}`);
    },                              
  },
};
</script>
<style>
#style-3::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px #535151;;
	background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar
{
	width: 6px;
	background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb
{
	background-color: #535151;
}
.divhidden{
  visibility:hidden;
}
.frams{
  cursor: pointer;
  width:685px;
  height:230px;
  background-color: #bdcbe2;
  border-style:dotted;
  border-width:2px;
  border-radius: 17px;
  border-color:#385e97;
}
.disabled-row {
  background-color: #f1de6e;
  pointer-events: none;
}
.checkboxcss{
  background-color:#f0f2f5;
  margin:6px;
  padding:5px;
  border-style:dotted;
  border-width:1px;
  border-color:#d0d2d5;
}

</style>


